import { Component, OnInit } from '@angular/core';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { GetStockItem$Params } from 'src/api/generated/fn/inventory/get-stock-item';
import { RestockInventoryItem$Params } from 'src/api/generated/fn/inventory/restock-inventory-item';
import { GetAllSuppliers$Params } from 'src/api/generated/fn/supplier/get-all-suppliers';
import { GetTaxRates$Params } from 'src/api/generated/fn/tax-rate-v-2/get-tax-rates';
import { RestockInventoryItemDto } from 'src/api/generated/models/Digiwork/MaitreD/Pos/DTO/PurchesOrders/restock-inventory-item-dto';
import { SupplierDto } from 'src/api/generated/models/Digiwork/MaitreD/Pos/DTO/Suppliers/supplier-dto';
import { TaxRateV2Dto } from 'src/api/generated/models/Digiwork/MaitreD/Pos/DTO/TaxRatesV2/tax-rate-v-2-dto';
import { InventoryService, SupplierService, TaxRateV2Service } from 'src/api/generated/services';
import { AuthenticationService } from 'src/app/share-modul/services/authentication/authentication.service';
import { AddOrEditSupplierComponent } from '../../supplier/add-or-edit-supplier/add-or-edit-supplier.component';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-item-restock',
  templateUrl: './item-restock.component.html',
  styleUrls: ['./item-restock.component.scss']
})
export class ItemRestockComponent implements OnInit {

  inventoryId: string;
  stockItemId: string;
  restockItem: RestockInventoryItemDto = {} as RestockInventoryItemDto;;

  taxAmount: number;
  grossAmount: number;
  
  suppliers: Array<SupplierDto>;
  taxRates: Array<TaxRateV2Dto>;

  constructor(private ref: DynamicDialogRef,
              private config: DynamicDialogConfig,
              private inventoryService: InventoryService,
              private taxRateService: TaxRateV2Service,
              private authenticationService: AuthenticationService,
              private supplierService: SupplierService,
              public dialogService: DialogService) {

    if (this.config.data != undefined) {
      if (this.config.data.stockItemId){
        this.stockItemId = this.config.data.stockItemId;
        const params: GetStockItem$Params = { stockItemId: this.config.data.stockItemId };
        this.inventoryService.getStockItem(params).subscribe(response => this.restockItem.stockItem = response );
      }
      if (this.config.data.inventoryId){
        this.inventoryId = this.config.data.inventoryId;
      }
    }

    const companyId = this.authenticationService.getCompanyId();
    const taxRatesParams: GetTaxRates$Params = { companyId: companyId, isRemoved: false };
    this.taxRateService.getTaxRates(taxRatesParams).subscribe( response => this.taxRates = response.taxRates ? response.taxRates : [] );

    this.loadSuppliers();  
  }

  ngOnInit(): void {
  }
  loadSuppliers(){
    const suppliersParams: GetAllSuppliers$Params = { isRemoved: false };
    this.supplierService.getAllSuppliers(suppliersParams).subscribe( response => this.suppliers = response.suppliers ? response.suppliers : [] );
  }

  addNewSupplier(){
    const ref = this.dialogService.open(AddOrEditSupplierComponent, {
      width: '372px',
      showHeader: false
    });
    ref.onClose.subscribe((item: any) => {
      if(item){
        this.loadSuppliers();  
      }
    }); 
  }
  
  apply(f:NgForm){
    if(f.valid){
      const restockParams: RestockInventoryItem$Params = { inventoryId: this.inventoryId, stockItemId: this.stockItemId, body: this.restockItem };
      this.inventoryService.restockInventoryItem(restockParams).subscribe({next: response => this.ref.close(true), error: errorResponse => this.ref.close(errorResponse)});
    }
  }

  cancel(){
    this.ref.close(null);
  }
}
